import React, { StrictMode, useEffect, useMemo, useState } from 'react';

import { isDevNodeEnv } from '@rover/rsdk/src/modules/Env/node';

export interface StrictModeContextValue {
  isStrictModeMounting: boolean;
}

const StrictModeContext = React.createContext<StrictModeContextValue>({
  isStrictModeMounting: false,
});

export const useStrictModeContext = (): StrictModeContextValue =>
  React.useContext(StrictModeContext);

export const StrictModeContextProvider: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const [isStrictModeMounting, setIsStrictModeMounting] = useState(isDevNodeEnv());
  const memoizedContextValue: StrictModeContextValue = useMemo(
    () => ({ isStrictModeMounting }),
    [isStrictModeMounting]
  );

  useEffect(() => {
    setIsStrictModeMounting(false);
  }, []);

  return (
    <StrictMode>
      <StrictModeContext.Provider value={memoizedContextValue}>
        {children}
      </StrictModeContext.Provider>
    </StrictMode>
  );
};
